export const PERCENT = 0;
export const MONEY = 1;
export const PERIODIC_PROMOTIONS = 1;
export const FLASH_SALE = 2;
export const SCHOOL_LINK = 3;
export const OTHER_SCHOOL = 4;
export const DIGITAL = 5;
export const SATELLITE = 8;
